<bw-spinner-legacy *ngIf="!findMoneyData.length"></bw-spinner-legacy>

<div *ngIf="findMoneyData.length > 0" class="carousel">
  <div
    class="carousel-track"
    [style.transform]="'translateX(-' + currentIndex * 100 + '%)'"
    [style.transition]="'transform 400ms ease'"
  >
    <div class="carousel-slide" *ngFor="let partner of findMoneyData">
      <bw-action-card-legacy
        [cardConfig]="mapToCardConfig(partner)"
        (ctaClicked)="onCtaClicked(partner)"
      ></bw-action-card-legacy>
    </div>
  </div>

  <div class="carousel-dots">
    <bw-icon-legacy (click)="prev()" [iconName]="'chevron_left'"></bw-icon-legacy>
    <span
      *ngFor="let item of findMoneyData; let i = index"
      (click)="goTo(i)"
      [class.active]="i === currentIndex"
    ></span>
    <bw-icon-legacy (click)="next()" [iconName]="'chevron_right'"></bw-icon-legacy>
  </div>
</div>
